import React from "react";
import InputRadio from "components/atoms/InputRadio";
import InputSelect from "components/atoms/InputSelect";
import { UserLevel } from "utils/constant";

const LevelFilter = ({
  currentUser,
  selectedLevel,
  setSelectedLevel,
  levelData,
  levelDataOptions,
  setLevelIdValue,
  selectedProvince,
  setSelectedProvince,
  selectedDistrict,
  setSelectedDistrict,
  showRegion = true,
}) => {
  const renderInputs = () => {
    switch (selectedLevel) {
      case UserLevel.Province:
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Provinsi"}
                data={levelDataOptions.provinces}
                onChange={(e) => {
                  setSelectedProvince(e.value);
                  setLevelIdValue(e.value);
                }}
                value={
                  levelDataOptions.provinces?.find(
                    (item) => item.value === selectedProvince
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ? false : true
                }
              />
            </div>
          </div>
        );

      case UserLevel.District:
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Provinsi"}
                data={levelDataOptions.provinces}
                onChange={(e) => {
                  setSelectedProvince(e.value);
                  setSelectedDistrict("");
                }}
                value={
                  levelDataOptions.provinces?.find(
                    (item) => item.value === selectedProvince
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ? false : true
                }
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Kab/Kota"}
                data={
                  currentUser?.level === UserLevel.District
                    ? levelDataOptions.districts?.filter(
                        (item) => item.value === currentUser?.district_id
                      )
                    : levelDataOptions.districts
                }
                onChange={(e) => {
                  setSelectedDistrict(e.value);
                  setLevelIdValue(e.value);
                }}
                value={
                  levelDataOptions.districts?.find(
                    (item) => item.value === selectedDistrict
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ||
                  currentUser.level === UserLevel.Province
                    ? false
                    : true
                }
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <InputRadio
        name={`level_${selectedLevel}`}
        options={levelData}
        onChange={(e) => {
          const value = e.target.value;
          setSelectedLevel(value);

          if (value !== currentUser.level) setLevelIdValue("");
          else {
            const levelMap = {
              [UserLevel.District]: currentUser?.district_id,
              [UserLevel.Province]: currentUser?.province_id,
            };
            setLevelIdValue(levelMap[value] || "");
          }
        }}
        selectedOption={selectedLevel}
      />
      {showRegion && (
        <div className="advanced-filter">
          {renderInputs()}
        </div>
      )}
    </>
  );
};

export default LevelFilter;
